<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <validation-observer ref="form" tag="div">
      <div class="text-center mb-3">
        <h4>{{ approveConfirmTitle }}</h4>
        <p class="m-0" v-html="approveConfirmDescription"></p>
      </div>
      <b-form-group
          :label="lodash.startCase($t('purchase_plans.modal_messages.approve_reason_label'))"
          class="mt-3"
          label-for="approve-reason"
      >
        <b-form-textarea
            id="approve-reason"
            v-model="form.reason"
            :placeholder="$t('purchase_plans.modal_messages.approve_reason_placeholder')"
            rows="4"
        />
      </b-form-group>
    </validation-observer>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ $t('Cancel') }}</b>
        </b-button>
        <b-button
            block
            class="m-0"
            variant="primary"
            @click="handleConfirm"
        >
          <b>{{ lodash.startCase($t('purchase_plans.buttons.yes_confirm')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'

export default {
  name: 'purchase-plan-approve-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-approve-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      options: {
        message: null,
        modelId: null,
      },
      form: {
        reason: '',
      },
      resolvePromise: null,
    };
  },
  computed: {
    approveConfirmTitle() {
      return this.options.title || `${this.$t('purchase_plans.modal_messages.confirm_approve_title')}?`
    },
    approveConfirmDescription() {
      if (this.options.message) {
        return this.options.message
      }

      const description = this.$t('purchase_plans.modal_messages.{something}_confirm_approve_description')
      const safeSomething = this.lodash.escape(this.options.modelId || this.$route.params.key)

      return description.replace('{something}', `<strong>${safeSomething}</strong>`)
    }
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          message: null,
          modelId: null,
          ...options,
        }
        this.form.reason = ''
        this.$bvModal.show(this.id)

        this.resolvePromise = resolve

        this.$nextTick(() => {
          this.$refs.form?.reset()
        })
      });
    },
    async handleConfirm() {
      if (!this.$refs.form) {
        return
      }

      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      if (this.resolvePromise) {
        this.resolvePromise({
          reason: this.form.reason.trim(),
        })
      }
      this.hide()
    },
    handleCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
